import React, { Component } from 'react';
import { connect } from 'react-redux'
import classnames from 'classnames'

import barPaths from '../constants/barPaths'
import gapCapSets from '../constants/gapCapSets'

import { addPathText, addCompleteIcon, inArray, itemIndex } from '../utilities'

import tooltips from '../constants/tooltips.json'

import {
	selectLearnBar
} from '../actions/'

class MalletStationBarsLearn extends Component {
	componentDidMount() {
		// add [bar index, soft-completed, hard-completed]
		const bars = [...document.querySelectorAll('.learn-mode-editor .mallet-station-bars path')]
		bars.forEach((bar,i) => {
			addPathText(bar, i)
			addCompleteIcon(bar, i, 'soft')
			addCompleteIcon(bar, i, 'hard')
		})
		// highlight initial bar / index since autoMode is on by default
		document.querySelectorAll('text.bar-index-text').forEach((t,i) => t.classList[(this.props.selectedLearnBar === i) ? 'add' : 'remove']('active'))
	}

	shouldComponentUpdate(nextProps) {
		const currentCount = this.props.completedStrikes.reduce((total, s) => total + s),
					nextCount = nextProps.completedStrikes.reduce((total, s) => total + s),
					currentBar = this.props.selectedLearnBar,
					nextBar = nextProps.selectedLearnBar,
					currentErrorBars = this.props.errorLearnBars,
					nextErrorBars = nextProps.errorLearnBars,
					currentLearnModeRecording = this.props.learnModeRecording,
					nextLearnModeRecording = nextProps.learnModeRecording,
					currentlearnModeAuto = this.props.learnModeAuto,
          nextlearnModeAuto = nextProps.learnModeAuto

		return (currentBar !== nextBar) ||
					 (currentCount !== nextCount) ||
					 (!currentErrorBars.sort().every((value, index) => value === nextErrorBars.sort()[index])) ||
					 (currentErrorBars.length !== nextErrorBars.length) ||
					 (currentLearnModeRecording !== nextLearnModeRecording) ||
					 (currentlearnModeAuto !== nextlearnModeAuto)
	}

	componentDidUpdate() {
		this.props.completedStrikes.forEach((status, index) => {
			let c, t
			switch (status) {
				case 1:
					// soft
					c = document.querySelector(`[data-bar-circle="${index}"][data-bar-circle-strike="soft"]`)
					if(c) c.setAttribute('data-bar-strikes-complete', true)
					t = document.querySelector(`[data-bar-strike-type="${index}"][data-bar-strike="soft"]`)
					if(t) t.setAttribute('data-bar-strikes-complete', true)
					break;
				case 2:
					// hard: w/out soft; if the user decided to do hard strikes first
					c = document.querySelector(`[data-bar-circle="${index}"][data-bar-circle-strike="hard"]`)
					if(c) c.setAttribute('data-bar-strikes-complete', true)
					t = document.querySelector(`[data-bar-strike-type="${index}"][data-bar-strike="hard"]`)
					if(t) t.setAttribute('data-bar-strikes-complete', true)
					break;
				case 3:
					// hard: w/ soft
					c = document.querySelector(`[data-bar-circle="${index}"][data-bar-circle-strike="hard"]`)
					if(c) c.setAttribute('data-bar-strikes-complete', true)
					t = document.querySelector(`[data-bar-strike-type="${index}"][data-bar-strike="hard"]`)
					if(t) t.setAttribute('data-bar-strikes-complete', true)
					// soft
					c = document.querySelector(`[data-bar-circle="${index}"][data-bar-circle-strike="soft"]`)
					if(c) c.setAttribute('data-bar-strikes-complete', true)
					t = document.querySelector(`[data-bar-strike-type="${index}"][data-bar-strike="soft"]`)
					if(t) t.setAttribute('data-bar-strikes-complete', true)
					break;
				default:
					// console.log('no bar');
			}
		})
		// toggle 'active' class on bar index text
		document
      .querySelectorAll("text.bar-index-text")
      .forEach((t, i) =>
        t.classList[this.props.selectedLearnBar === i ? "add" : "remove"](
          "active"
        )
      );
	}

	handleClick = (e) => {
		const elType = e.target.nodeName

		if(elType !== 'path') return

		const {
			onSelectLearnBar
		} = this.props
		const selectedBar = ~~e.target.dataset.bar

		onSelectLearnBar(selectedBar)
	}

	handleEnter = (e) => {
		// console.log('enter', e.target.nodeName)
	}

	handleLeave = (e) => {
		// console.log('leave', e.target.nodeName)
	}

	render() {
		const {
			gapCaps,
			lowNote,
			selectedLearnBar,
			errorLearnBars,
			learnModeRecording,
			learnModeAuto,
			completedStrikes,
			showTooltips
		} = this.props

		const selectedSet = gapCapSets[lowNote]
		let barID = 0

		return (
      <div
        className={classnames(
          "bars-wrapper",
          { recording: learnModeRecording },
          { automode: learnModeAuto }
        )}
        data-tip={tooltips["learn-mode-bars"]}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
      >
        <svg
          className={classnames("mallet-station-bars")}
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 3157 741.4"
          onClick={this.handleClick}
          onMouseEnter={this.handleEnter}
          onMouseLeave={this.handleLeave}
        >
          {barPaths.map((bar, index) => {
            barID += itemIndex(selectedSet, index) !== -1 ? 0 : 1;
            // note: ID is consecutive minus gap cap bars
            return (
              <path
                id={
                  inArray(selectedSet, index)
                    ? "gap_" + itemIndex(selectedSet, index)
                    : "bar_" + barID
                }
                key={bar.id}
                className={classnames(
                  "bar",
                  { active: selectedLearnBar === ~~bar.id },
                  { learned: completedStrikes[index] === 3 },
                  { error: errorLearnBars.includes(selectedLearnBar) }
                )}
                data-bar={index}
                data-note={gapCaps.notes[itemIndex(selectedSet, index)]}
                d={bar.d}
              ></path>
            );
          })}
        </svg>
      </div>
    );
	}
}

const mapStateToProps = (state) => {
  return {
		gapCaps: state.currentPreset.gapCaps,
		lowNote: state.currentPreset.lowNote,
    selectedLearnBar: state.editor.selectedLearnBar,
    errorLearnBars: state.editor.errorLearnBars,
    learnModeRecording: state.editor.learnModeRecording,
		learnModeOpen: state.editor.learnModeOpen,
		learnModeAuto: state.editor.learnModeAuto,
		learnModeStrikeType: state.editor.learnModeStrikeType,
		learnRecords: state.learnMode.records,
		completedStrikes: state.learnMode.completedStrikes,
		showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		onSelectLearnBar: (bar) => {
			dispatch(selectLearnBar(bar))
		}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MalletStationBarsLearn)
